/**
 * 0079 — filter skills/templates to the "Interview Guide Generator" tag.
 * Aligns with `tasks.md` / spec: case-insensitive match on tag text.
 */

const NEEDLE = 'interview guide generator';

/**
 * Return true when the provided tag array contains the "Interview Guide Generator" tag.
 *
 * Matching is case-insensitive and trims whitespace from each tag before comparing.
 *
 * @param tags - Tag array from a skill template or project skill record; may be null/undefined.
 */
export function skillTagsIncludeInterviewGuide(tags: string[] | undefined | null): boolean {
  if (!tags?.length) {
    return false;
  }
  return tags.some((t) => t.trim().toLowerCase().includes(NEEDLE));
}

/** The filesystem key for the canonical bundled interview-guide skill template. */
export const BUNDLED_INTERVIEW_GUIDE_TEMPLATE_KEY = 'interview-guide-generator';
